
import ogPagesMixins from '@/mixins/ogPagesMixins'

// Начальный лимит данных
const LIMIT = 15

// Url адрес для запроса данных
const URL = '/experts/streams/all'

export default {
  mixins: [ogPagesMixins],
  scrollToTop: true,
  props: {
    community: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      experts: [],
      expertsCount: 0,
      page: this.$route.query?.page ? this.$route.query.page : 1,
    }
  },
  async fetch() {
    await this.fetchExperts()
  },
  computed: {
    seoTitle() {
      return `Сообщество ${this.community?.title} : эксперты | Мегасреда`
    },
    seoDescription() {
      return `Все эксперты сообщества ${this.community?.title}`
    },
    seoH1() {
      return `Пользователи и компании публикующие материалы для сообщества ${this.community?.title}`
    },
    seoImage() {
      return {
        url: `https://api.megasreda.ru/image/ogimage/community/${this.community?._id}.jpg`,
        urlVk: `https://api.megasreda.ru/image/ogimage/community/vk/${this.community?._id}.jpg`,
        urlTw: `https://api.megasreda.ru/image/ogimage/community/${this.community?._id}.jpg`,
        type: 'image/jpeg',
        width: 1200,
        height: 630,
      }
    },
    pageCount() {
      return Math.ceil(this.expertsCount / LIMIT)
    },
    expertsOffset() {
      return (this.page - 1) * LIMIT
    },
  },
  watch: {
    $route() {
      if (!this.$route.query?.page) {
        this.page = 1
        this.experts = []
        this.$router.push({
          query: {},
        })
        this.fetchExperts()
      }
    },
  },
  methods: {
    paginateClick(page) {
      this.experts = []
      if (page === 1) {
        this.$router.push({
          query: {},
        })
      } else {
        this.$router.push({
          query: {
            ...this.$route.query,
            page: this.page,
          },
        })
        this.fetchExperts()
      }
      this.$scrollTo('body')
    },

    async loadMore() {
      this.page++
      this.$router.push({
        query: {
          ...this.$route.query,
          page: this.page,
        },
      })
      await this.fetchExperts()
    },

    async fetchExperts() {
      const streamsIds = this.community.streams?.map((stream) => stream._id)
      const { experts, countAllExperts } = await this.$axios.$get(URL, {
        params: {
          streams: streamsIds,
          limit: LIMIT,
          offset: this.expertsOffset,
        },
      })

      this.expertsCount = countAllExperts
      this.experts = this.experts?.length
        ? this.experts.concat(experts)
        : experts
    },
  },
}
